var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsAudienceOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DB536A;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#E0301E;}\n\t.st3{fill:#D04A02;}\n\t.st4{fill:#464646;}\n\t.st5{fill:#7D7D7D;}\n\t.st6{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.5,34.3c0-8.2-6.7-14.9-14.9-14.9c-8.2,0-14.9,6.7-14.9,14.9s6.7,14.9,14.9,14.9C44.8,49.2,51.5,42.5,51.5,34.3z  M26.1,34.3c0-5.8,4.7-10.4,10.4-10.4c5.8,0,10.4,4.7,10.4,10.4c0,5.8-4.7,10.4-10.4,10.4C30.8,44.7,26.1,40.1,26.1,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,45.1c0-6.5-5.3-11.8-11.8-11.8c-6.5,0-11.8,5.3-11.8,11.8c0,6.5,5.3,11.8,11.8,11.8C79.1,56.8,84.3,51.6,84.3,45.1z  M65.3,45.1c0-4,3.3-7.3,7.3-7.3c4,0,7.3,3.3,7.3,7.3c0,4-3.3,7.3-7.3,7.3C68.6,52.3,65.3,49.1,65.3,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,62.7v-1.9l-1.3-0.6c-11.8-5.8-28.7-5.8-40.5,0L16,60.8v18.8h38.6h4.5H88v-15L86.7,64C78.8,60.1,67.7,59.7,59.1,62.7z  M54.6,64.6v10.5H20.5V63.7c10.1-4.4,24-4.4,34.1,0V64.6z M83.5,75.2H59.1v-7.7c7.2-3.1,17.2-3.1,24.4,0V75.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAudienceOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Audience_Outline_Brand.8af6332388a369e0d8bd3598996698aa.svg";
export { ForwardRef as ReactComponent };